<template>
    <!-- 安全校园-多媒体管理-新增编辑 -->
    <div class="main">
        <div class="school_check">
            <el-page-header @back="goBack" :content="contentTitle"></el-page-header>
        </div>
        <div class="form_body">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="播放名称：" prop="screen_name">
                    <el-input v-model="ruleForm.screen_name"></el-input>
                </el-form-item>
                <el-form-item label="播放类型：" prop="play_type">
                    <el-select v-model="ruleForm.play_type" placeholder="请选择">
                        <el-option v-for="item in playType" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="播放次数：" prop="frequency">
                    <el-input v-model.number="ruleForm.frequency"></el-input>
                </el-form-item>
                <el-form-item label="设备类型：" prop="screen_type">
                    <el-select v-model="ruleForm.screen_type" placeholder="请选择" @change="resView()">
                        <el-option v-for="item in screenTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备选择：">
                    <el-button size="small" type="primary" @click="screenClick">设备选择</el-button>
                </el-form-item>
                <el-form-item label="上传方式：" prop="file_source">
                    <el-radio-group v-model="ruleForm.file_source" @change="sourceChange">
                        <el-radio :label="2">上传新文件</el-radio>
                        <el-radio :label="1">素材库选择</el-radio>
                    </el-radio-group>
                </el-form-item>

                <!-- 原有功能 -->
                <div v-if="ruleForm.file_source == 1">
                    <el-form-item label="素材类型：" prop="show_type">
                        <el-select v-model="ruleForm.show_type" placeholder="请选择" @change="showChange">
                            <el-option v-for="item in showTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <!-- show_type 1图片2视频 -->
                    <el-form-item :label="ruleForm.show_type==1?'选择图片：':'选择视频：'">
                        <el-button size="small" type="primary" @click="showClick">素材选择</el-button>
                    </el-form-item>
                    <el-form-item style="max-height: 200px;overflow: auto;">
                        <div v-if="ruleForm.show_type==2&&previewData.length>0">
                            {{'目前播放时长：'+timestr}}
                        </div>
                        <div v-if="previewData.length>0">
                            <template v-for="(item,index) in previewData">
                                <span :key="index" v-if="ruleForm.show_type==1&&item!='undefined'" class="par">
                                    <el-image style="width: 100px; height: 100px;margin-right:5px;" :src="baseUrl+item.file_path" :preview-src-list="[baseUrl+item.file_path]">
                                    </el-image>
                                    <!-- <el-button icon="el-icon-close" size='mini' class="son" circle @click="del(item,index)"></el-button> -->
                                </span>
                                <span v-else-if="ruleForm.show_type==2&&item!='undefined'" :key='index' class="par">
                                    <video height="100px" :src="baseUrl+item.file_path" @click="videoClick(baseUrl+item.file_path)"></video>
                                    <!-- <el-button icon="el-icon-close" size='mini' class="sonv" circle @click="del(item,index)"></el-button> -->
                                </span>
                            </template>
                        </div>
                    </el-form-item>
                </div>

                <!-- 新功能 -->
                <div v-if="ruleForm.file_source == 2">
                    <el-form-item label="素材名称：" prop="source_name">
                        <el-input v-model="ruleForm.source_name" placeholder="请输入素材名称" maxlength="20"></el-input>
                    </el-form-item>
                    <el-form-item label="素材类型：" prop="show_type">
                        <el-select v-model="ruleForm.show_type" placeholder="请选择" @change="showChange">
                            <el-option v-for="item in showTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="上传附件：" prop="file_ids">
                        <el-upload ref="upload" class="upload-demo" :action="upload.fileUrl" :limit="upload.limit" :data="upload.data" :headers="upload.headers" :file-list="fileShowList" :on-preview="handlePreview" :before-upload="(file) => uploadBefore(file)" :on-success="(response, fileList, file) => uploadSuccess(response, file, fileList)" :on-error="uploadError" :on-remove="(file, fileList) => uploadRemove(file, fileList)" :on-exceed="overstepLimit" multiple :accept="upload.fileTypes">
                            <el-button size="small" type="primary" :disabled="upload.disabled" @click.stop="showTypeCheck">点击上传</el-button>
                            <span slot="tip" class="el-upload__tip" style="margin-left: 20px;">{{ upload.tips }}</span>
                        </el-upload>
                    </el-form-item>
                    <el-form-item style="max-height: 200px;overflow: auto;">
                        <div v-if="ruleForm.show_type==2&&fileShowList.length>0">
                            {{'目前播放时长：'+ durationStr}}
                        </div>
                    </el-form-item>
                </div>

                <el-form-item>
                    <!-- 确定按钮 -->
                    <!-- <div slot="footer" class="dialog-footer"> -->
                    <el-button type="primary" style="width: 250px;margin-top: 20px;" class="btn" @click="submitForm('ruleForm')" :disabled="upload.disabled">确 定</el-button>
                    <!-- <el-button @click="resetForm('ruleForm')">取 消</el-button> -->
                    <!-- </div> -->
                </el-form-item>
            </el-form>
        </div>

        <el-dialog v-dialogDrag title="选择设备" :visible.sync="screenVisible" width="30%" @close="screenVisible=false" :close-on-click-modal="false">
            <el-form>
                <el-form-item style="display: block;">
                    <el-checkbox v-model="isSelectAll" @change="selectAll">全选/全不选</el-checkbox>
                    <el-tree :data="nodeData" show-checkbox check-on-click-node node-key="device_id" ref="tree" :props="defaultProps">
                    </el-tree>
                </el-form-item>
                <el-form-item>
                    <el-button @click="screenSubmit">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog v-dialogDrag :title="showTitle" :visible.sync="showTypeVisible" width="40%" @close="showTypeVisible=false" :close-on-click-modal="false">
            <el-input placeholder="请输入素材名称" v-model="keyword" clearable size="small" style="width:30%;margin-bottom:10px;" @change="resView"></el-input>
            <div class="home_table">
                <el-table :data="showNodeData" :row-key="getRowKey" ref="multipleTable" border element-loading-background="rgba(0, 0, 0, 0.4)" :max-height="tableHeight" size="medium" style="width: 100%" @cell-click='cellClick' @selection-change='select'>
                    <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
                    <template v-for="(item, index) in tableHead">
                        <el-table-column :prop="item.prop" align="center" :label="item.title" :key="index" :min-width="item.minWidth" :show-overflow-tooltip="true"></el-table-column>
                    </template>
                    <el-table-column prop="address" label="素材预览" align="center" fixed="right" min-width="100">
                        <template slot-scope="scope">
                            <el-image v-if="scope.row.file_type==1" style="width: 50px; height: 50px" :src="baseUrl+scope.row.file_path" :preview-src-list="[baseUrl+scope.row.file_path]">
                            </el-image>
                            <video v-else-if="scope.row.file_type==2" :src="baseUrl+scope.row.file_path" height="50px"></video>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- <div class="pagination">
                <el-pagination background :current-page.sync="page" :page-sizes="[5, 10, 15, 30]" :page-size="page_size" layout="prev, pager, next, sizes,total" :total="total" class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :hide-on-single-page="total<5? true:false" />
            </div> -->
        </el-dialog>
    </div>
</template>
<script>
import {
    multimediaList, multimediaView, multimediaInfo, multimediaAdd, multimediaEdit, multimediaDel, multimediaStop, uploadApiFile, uploadApi, hashApi
} from '@/api/index';
export default {
    data() {
        return {
            contentTitle: '',
            ruleForm: {
                screen_name: '',//播放名称
                frequency: '',//播放次数
                screen_type: '',//设备类型
                source_name: '',//素材名称
                file_source: 2,//上传方式 1从素材中心选，2上传新文件
                show_type: '',//素材类型
                play_type: '',
            },
            rules: {
                screen_name: [
                    { required: true, message: '请输入播放名称', trigger: 'blur' },
                    // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                frequency: [
                    { required: true, message: '请输入播放次数', trigger: 'blur' },
                    { type: 'number', message: '请输入大于等于零的整数' }
                ],
                source_name: [
                    { required: true, message: '请输入素材名称', trigger: 'blur' },
                ],
                screen_type: [
                    { required: true, message: '请选择设备类型', trigger: 'change' }
                ],
                show_type: [
                    { required: true, message: '请选择素材类型', trigger: 'change' }
                ],
                play_type: [
                    { required: true, message: '请选择播放类型', trigger: 'change' }
                ],
            },
            screenTypeList: [],//设备类型列表
            showTypeList: [],//素材类型列表
            playType: [],//播放类型列表
            showTitle: '选择图片',//素材选择title
            showTypeVisible: false,//素材选择弹窗
            screenVisible: false,
            nodeData: [],//设备树状列表
            showNodeData: [],//素材表格列表
            defaultProps: {
                children: 'children',
                label: 'device_name',
            },
            // tree是否全选，复选框默认状态（）
            isSelectAll: false,
            device_ids: [],
            screen: [],
            showType: [],
            tableHead: [
                { title: '素材名称', prop: 'title', minWidth: '100' },
                { title: '素材时长', prop: 'duration', minWidth: '100' },
            ],
            tableHeight: '500px',
            total: 0,
            page: 1,
            page_size: 5,
            tableHeadCopy: [],
            baseUrl: '',
            keyword: '',
            file_ids: [],//素材id
            fileShowList: [],
            hash: '',
            previewData: [],
            previewDataCopy: [],
            infoId: '',
            timestr: '',//选择素材的时长
            durationStr: '',//上传新文件的时长
            //上传附件
            upload: {
                fileUrl: uploadApiFile, //小于500M文件
                imgUrl: uploadApi,
                headers: { token: localStorage.getItem('token') },
                fileTypes: '',//可变化文件类型
                tips: '',//可变化提示信息
                data: {
                    source: 'source',
                    source_id: 0,
                    source_type: 'files',
                    hash: '',
                },
                limit: 9,
                open: false,
                title: '',
                disabled: false,
            },
            audioDuration: 0,//文件时长
        }
    },
    mounted() {
        this.infoId = this.$route.params.id;
        if (this.$route.params.id) {
            this.getInfo(this.infoId)
        }
        this.getHash();
        this.resView()
        this.tableHeadCopy = JSON.parse(JSON.stringify(this.tableHead));
        this.baseUrl = process.env.UPLOADER_URL;
    },
    methods: {
        getRowKey(row) {
            return row.id;
        },
        videoClick(e) {
            window.open(e, '_blank')
        },
        cellClick(row, column, cell, event) {
            if (row.file_type == 2 && column.fixed == 'right') {
                window.open(this.baseUrl + row.file_path, '_blank')
            }
        },

        // 上传方式-对应文件清空 
        sourceChange() {
            this.fileShowList = [];
            this.file_ids = [];
            this.previewData = [];
            this.durationStr = '';
        },
        // 上传附件-button按钮
        showTypeCheck() {
            if (this.ruleForm.show_type == '') {
                this.$message({
                    showClose: true,
                    message: '请先选择素材类型',
                    type: "warning"
                });
                return;
            } else {
                this.$refs['upload'].$refs['upload-inner'].handleClick() //重点是这句
            }
        },
        // 监听 page_size 改变
        handleSizeChange(newSize) {
            this.page = 1;
            this.page_size = newSize;
            this.resView();
        },
        // 监听 pagenum 改变
        handleCurrentChange(newPage) {
            this.page = newPage;
            this.resView();
        },
        selectAll() {
            if (this.isSelectAll) {
                // 	设置目前勾选的节点，使用此方法必须设置 node-key 属性
                this.$refs.tree.setCheckedNodes(this.nodeData);
            } else {
                // 全部不选中
                this.$refs.tree.setCheckedNodes([])
            }
        },
        async getNodeData(e) {
            this.nodeData = [];
            let data = {
                screen_type: this.ruleForm.screen_type ? this.ruleForm.screen_type : '',
            }
            const res = await this.axios.post(multimediaView, data)
            if (res.data.code == 1) {
                this.nodeData = res.data.data.device_list;
                if (e) {
                    this.$nextTick(function () {
                        this.$refs.tree.setCheckedKeys([]);
                        e.forEach((i) => {
                            var node = this.$refs.tree.getNode(i);
                            if (node) {
                                this.$refs.tree.setChecked(node, true);
                            }
                        });
                    })
                } else {
                    // 获取所有id 赋值树节点
                    const arr = [];
                    this.nodeData.forEach(data => {
                        arr.push(data.device_id)
                        if (data.children) {
                            data.children.forEach(item => {
                                arr.push(item.device_id)
                            })
                        }
                    });
                    this.$nextTick(function () {
                        this.$refs.tree.setCheckedKeys(arr);
                    })
                }

            } else {
                this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: "error"
                });
            }
        },

        //设备选择
        screenClick() {
            if (this.ruleForm.screen_type == '') {
                this.$message({
                    showClose: true,
                    message: '请先选择设备类型',
                    type: "warning"
                });
                return;
            } else {
                this.screenVisible = true;
                this.isSelectAll = false;
                console.log(this.screen);
                // this.resView();
                this.$nextTick(() => {
                    if (this.ruleForm.screen_type == 1) {
                        this.showType = [];
                        this.getNodeData(this.screen);
                    } else if (this.ruleForm.screen_type == 2) {
                        this.screen = [];
                        this.getNodeData(this.showType);
                    }
                })
            }
        },
        //素材选择
        showClick() {
            if (this.ruleForm.show_type == '') {
                this.$message({
                    showClose: true,
                    message: '请先选择素材类型',
                    type: "warning"
                });
                return;
            } else {
                this.keyword = '';
                this.resView();
                if (this.ruleForm.show_type == 1) {
                    this.tableHead = this.tableHead.filter((e => {
                        return e.title !== '素材时长'
                    }))
                } else {
                    this.tableHead = this.tableHeadCopy;
                }
                this.showTypeVisible = true;
                this.$nextTick(() => {
                    this.previewData.forEach(e => {
                        if (typeof (this.showNodeData.find(item => item.id == e.id)) != 'undefined') {
                            this.$refs.multipleTable.toggleRowSelection(this.showNodeData.find(item => item.id == e.id), true);
                        }

                    })
                })
            }
        },
        //素材类型改变事件
        showChange(e) {
            this.file_ids = [];
            this.previewData = [];
            this.fileShowList = [];
            this.durationStr = '';
            this.uploadInfoChange(e);
        },
        uploadInfoChange(e) {
            if (e == 1) {
                this.showTitle = '选择图片';
                this.upload.fileTypes = '.jpg, .jpeg, .png';
                this.upload.limit = 9;
                this.upload.tips = '支持上传.jpg, .jpeg, .png格式；至多可上传9个文件，单个文件不可超过10M';
            } else if (e == 2) {
                this.showTitle = '选择视频';
                this.upload.fileTypes = '.mp4, .mov';
                this.upload.limit = 5;
                this.upload.tips = '支持上传.mp4, .mov格式；至多可上传5个文件，单个文件不可超过500M';
            }
        },
        goBack() {
            this.$router.go(-1);
        },
        async resView() {
            let data = {
                screen_type: this.ruleForm.screen_type ? this.ruleForm.screen_type : '',
                show_type: this.ruleForm.show_type ? this.ruleForm.show_type : '',
                // page: this.page,
                // page_size: this.page_size,
                title: this.keyword,
            }
            const res = await this.axios.post(multimediaView, data);
            if (res.data.code == 1) {
                this.nodeData = res.data.data.device_list;
                this.showNodeData = Object.prototype.toString.call(res.data.data.file_list) === '[object Object]' ? res.data.data.file_list.data : [];
                // this.total = res.data.data.file_list.total;
                this.screenTypeList = res.data.data.screen_type_list;
                this.playType = res.data.data.play_type_list;
                this.showTypeList = res.data.data.show_type_list;
            } else {
                this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error'
                });
            }
        },
        //提交
        screenSubmit() {
            if (this.ruleForm.screen_type == 1) {
                this.screen = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys());
            } else if (this.ruleForm.screen_type == 2) {
                this.showType = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys());
            }
            this.screenVisible = false;
        },
        //重置对话框表单
        resetForm() {
            this.ruleForm = {
                screen_name: '',//播放名称
                frequency: '',//播放次数
                screen_type: '',//设备类型
                source_name: '',//素材名称
                file_source: 2,//上传方式
                show_type: '',//素材类型
                play_type: '',
            };
            this.showType = [];
            this.screen = [];
            this.$nextTick(() => {
                this.$refs['ruleForm'].resetFields();
            })
        },
        //表单提交
        submitForm() {
            this.$refs['ruleForm'].validate(async valid => {
                if (valid) {
                    await this.getHash();
                    if (Number(this.ruleForm.frequency) < 0) {
                        this.$message({
                            showClose: true,
                            message: '播放次数请填写大于等于零的整数',
                            type: 'error'
                        });
                        return
                    }
                    if (this.ruleForm.play_type == 2 && Number(this.ruleForm.frequency) < 1) {
                        this.$message({
                            showClose: true,
                            message: '临时播放时次数需大于零',
                            type: 'error'
                        });
                        return
                    }

                    if (this.ruleForm.show_type == 1) {
                        if (this.file_ids.length > 9) {
                            this.$message({
                                showClose: true,
                                message: '图片素材最多选择九张',
                                type: 'error'
                            });
                            return
                        }
                    } else if (this.ruleForm.show_type == 2) {
                        if (this.file_ids.length > 5) {
                            this.$message({
                                showClose: true,
                                message: '视频素材最多选择五个',
                                type: 'error'
                            });
                            return
                        }
                    }
                    let numReg = /^[0-9]*$/
                    let numRe = new RegExp(numReg)
                    let arr = [];
                    // 文件时长遍历保存
                    const length_arr = this.fileShowList.map(item => item.file_length);
                    if (this.ruleForm.screen_type == 1) {
                        this.screen.forEach(e => {
                            if (numRe.test(e)) {
                                arr.push(e);
                            }
                        })
                    } else if (this.ruleForm.screen_type == 2) {
                        this.showType.forEach(e => {
                            if (numRe.test(e)) {
                                arr.push(e);
                            }
                        })
                    }
                    let data = {
                        screen_name: this.ruleForm.screen_name,
                        frequency: this.ruleForm.frequency,
                        screen_type: this.ruleForm.screen_type,
                        play_type: this.ruleForm.play_type,
                        show_type: this.ruleForm.show_type,
                        source_name: this.ruleForm.source_name,
                        file_source: this.ruleForm.file_source,
                        file_ids: this.file_ids.join(','),
                        file_length: length_arr.join(','),
                        device_ids: arr.join(','),
                        hash: this.hash,
                    };
                    let api;
                    if (typeof this.infoId != 'undefined') {
                        api = multimediaEdit;
                        data.id = this.infoId;
                    } else {
                        api = multimediaAdd;
                    }
                    const res = await this.axios.post(api, data);
                    if (res.data.code == 1) {
                        this.$message({
                            showClose: true,
                            message: res.data.msg,
                            type: 'success'
                        });
                        this.$router.push('/multimediaManagement')
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.msg,
                            type: 'error'
                        });
                    }
                }
            })
        },
        select(selection) {
            let arr = [];
            if (selection.length > 0) {
                selection.forEach((e, index) => {
                    if (e.file_type == this.ruleForm.show_type) {
                        arr.push(e);
                    } else {
                        selection.splice(index, 1)
                    }
                })
            } else {
                arr = selection
            }
            this.previewData = arr;
            if (arr.length > 0) {
                this.file_ids = [];
                arr.forEach(e => {
                    if (typeof e != "undefined") {
                        this.file_ids.push(e.id)
                    }
                })
            } else {
                this.file_ids = [];
            }
            let time = 0;
            this.previewData.forEach((e, index) => {
                if (typeof e != "undefined") {
                    if (e.file_type == 2) {
                        time += e.file_length
                    }
                }
            })
            this.timestr = this.timeChange(time)
        },
        async getHash() {
            const datas = {
                page_hash: 'multimediAdd'
            };
            const res = await this.axios.post(hashApi, datas);
            if (res.data.code == 1) {
                this.hash = res.data.data;
            } else {
                this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error'
                });
            }
        },
        // del(item, index) {
        //     let num = this.file_ids.findIndex(i => i == item.id);
        //     this.file_ids.splice(num, 1)
        //     this.previewData.splice(index, 1);
        //     let time = 0;
        //     this.previewData.forEach((e, index) => {
        //         if (typeof e != "undefined") {
        //             if (e.file_type == 2) {
        //                 time += e.file_length
        //             }
        //         }
        //     })
        //     this.timestr = this.timeChange(time)
        // },
        async getInfo(id) {
            const res = await this.axios.post(multimediaInfo, { id: id });
            if (res.data.code == 1) {
                this.ruleForm = JSON.parse(JSON.stringify({ ...res.data.data, source_name: '', file_source: 1 }));//编辑时将上传方式改为素材中心选择
                this.ruleForm.source_name = res.data.data.file_data[0].title;//素材名称取文件列表第一个title
                this.device_ids = res.data.data.device_ids;
                this.file_ids = res.data.data.file_ids.length > 0 ? res.data.data.file_ids.split(',') : [];

                if (res.data.data.screen_type == 1) {
                    this.screen = res.data.data.device_ids;
                } else if (res.data.data.screen_type == 2) {
                    this.showType = res.data.data.device_ids;
                }
                // 根据文件类型改变上传参数
                this.uploadInfoChange(res.data.data.show_type);

                // 根据上传方式取文件信息
                // if (res.data.data.file_source == 1) {
                this.previewData = res.data.data.file_data;
                let time = 0;
                this.previewData.forEach((e, index) => {
                    if (typeof e != "undefined") {
                        if (e.file_type == 2) {
                            time += e.file_length
                        }
                    }
                })
                this.timestr = this.timeChange(time)
                // } else {
                //     let count = 0;
                //     res.data.data.file_data.forEach(item => {
                //         this.fileShowList.push({ name: item.file_name, url: this.baseUrl + item.file_path, file_id: item.id, file_length: item.file_length })
                //     })
                //     this.fileShowList.forEach(item => {
                //         count += item.file_length;
                //     })
                //     this.durationStr = this.timeChange(count);
                // }
                this.resView();
            } else {
                this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error'
                });
            }
        },
        timeChange(value) {
            let result = parseInt(value);
            let y = Math.floor(result / 86400) < 10 ? "0" + Math.floor(result / 86400) : Math.floor(result / 86400);

            let h = Math.floor((result / 3600) % 24) < 10 ? "0" + Math.floor((result / 3600) % 24) : Math.floor((result / 3600) % 24);

            let m = Math.floor((result / 60) % 60) < 10 ? "0" + Math.floor((result / 60) % 60) : Math.floor((result / 60) % 60);

            let s = Math.floor(result % 60) < 10 ? "0" + Math.floor(result % 60) : Math.floor(result % 60);

            let res = "";
            if (y !== "00") res += `${y}天`;

            if (h !== "00") res += `${h}时`;

            if (m !== "00") res += `${m}分`;

            res += `${s}秒`;

            return res;
        },

        // 上传前 type=1上传图片，2视频
        uploadBefore(file) {
            this.getHash();
            this.upload.disabled = true;
            // 将文件后缀转为小写
            let fileExt = file.name.replace(/.+\./, "").toLowerCase();
            let is500M = file.size / 1024 / 1024 < 500;
            let is10M = file.size / 1024 / 1024 < 10;

            if (this.ruleForm.show_type == 1) {
                if (this.upload.fileTypes.indexOf(`.${fileExt}`) == -1) {
                    this.$message.error('请上传.jpg, .jpeg, .png格式文件');
                    this.upload.disabled = false;
                    return false;
                }
                if (!is10M) {
                    this.$message.error("上传文件大小不能超过10MB!");
                    this.upload.disabled = false;
                    return false;
                }
            } else if (this.ruleForm.show_type == 2) {
                if (this.upload.fileTypes.indexOf(`.${fileExt}`) == -1) {
                    this.$message.error('请上传.mp4, .mov格式文件');
                    this.upload.disabled = false;
                    return false;
                }
                if (!is500M) {
                    this.$message.error("上传文件大小不能超过500MB!");
                    this.upload.disabled = false;
                    return false;
                }
                this.getTimes(file); // 获取文件的时长
            }
        },
        // 上传成功 type=1上传图片，2上传视频
        uploadSuccess(res, file, fileList) {
            this.upload.disabled = false;
            if (res.code == 1) {
                let count = 0;//记录总时长
                this.file_ids.push(res.file_id);
                this.fileShowList.push({ name: res.file_name, url: this.baseUrl + res.url, file_id: res.file_id, file_length: this.audioDuration });
                this.fileShowList.forEach(item => {
                    count += item.file_length;
                })
                this.durationStr = this.timeChange(count);
                this.audioDuration = 0;//时长重置为0

                this.$message({
                    showClose: true,
                    message: '上传成功',
                    type: "success"
                });
            } else {
                this.audioDuration = 0;//时长重置为0
                this.$message({
                    showClose: true,
                    message: res.msg,
                    type: "error"
                });
            };
            this.getHash();
        },
        // 附件删除 type=1上传图片，2上传视频
        uploadRemove(file, fileList) {
            if (file.status != 'success') {
                return;
            } else {
                let count = 0;//记录总时长
                this.file_ids = this.file_ids.filter(item => item != file.file_id);
                this.fileShowList = this.fileShowList.filter(obj => obj.file_id != file.file_id);
                this.fileShowList.forEach(item => {
                    count += item.file_length;
                })
                this.durationStr = this.timeChange(count);
            }
        },
        //上传失败
        uploadError(response) {
            this.$message({
                showClose: true,
                message: response.msg,
                type: "error"
            });
        },
        //超出文件个数限制
        overstepLimit(files, fileList) {
            if (files.length + fileList.length > this.upload.limit) {
                this.$message({
                    showClose: true,
                    message: '最多上传' + this.upload.limit + '个文件',
                    type: "warning"
                })
            }
        },
        // 点击文件列表中已上传的文件时的钩子
        handlePreview(file) { //上传附件预览
            window.open(file.url, "_blank")
        },

        // 获取上传文件时长  
        getTimes(file) {  //获取时长
            var content = file;
            var url = URL.createObjectURL(content);
            //经测试，发现audio也可获取视频的时长
            var audioElement = new Audio(url);
            console.log(audioElement);
            audioElement.addEventListener("loadedmetadata", (_event) => {
                this.audioDuration = parseInt(audioElement.duration);
            });
        },
    }
}
</script>
<style scoped lang='scss'>
.school_check {
    height: 60px;
    padding: 0 24px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.form_body {
    width: 40%;
    min-width: 40%;
    margin-left: 23%;
    .el-form {
        padding: 20px;
        .el-select {
            width: 100%;
        }
    }
}
.par {
    position: relative;
    .son {
        position: absolute;
        top: 0px;
        right: 0px;
    }
    .sonv {
        right: -8%;
        position: absolute;
        top: 0px;
    }
}
/deep/.el-dialog__body {
    height: 500px;
}
</style>


// WEBPACK FOOTER //
// src/views/multimediaManagement/multimediAdd.vue